import React, { useState, useContext, useEffect, useRef } from "react"
import {
  Card,
  CardActionArea,
  Typography,
  Button,
  IconButton,
  Box,
  Divider,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart"
import CreateIcon from "@material-ui/icons/Create"
import { size, color } from "../config"
import Modal from "../widgets/Modal"
import ProductInfo from "./ProductInfo"
import { Variant } from "./ProductInfo"
import Quantity from "../widgets/Quantity"
import TagPrice from "../widgets/TagPrice"
import search from "../lib/search"
import { CartContext } from "./Context"
import Img from "gatsby-image"

// import { ViewCart } from "./Context"
const useStyles = makeStyles(theme => ({
  Card: {
    // marginTop: size.big,
    // marginBottom: size.superBig * 1.5,
    position: "relative",
    // maxWidth: 350,
  },
  Container: {
    width: `calc( 100% - ${size.normal * 2}px)`,
    // height: "20vh",
    minHeight: "20vh",
    // maxHeight: "40vh",

    display: "flex",
    padding: size.normal,
  },
  ProductImgContainer: {
    width: `calc(50% - ${size.small * 2}px)`,
    height: "inheret",
    padding: size.small,
    "& .img": {
      width: "100%",
      borderRadius: size.small,
    },
  },
  ProductInfo: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    height: "inherit",
    width: "50%",
    "& .title": {
      lineHeight: "1.2em",
    },
    "& .price": {
      position: "absolute",
      top: size.big,
      left: 0,
    },
    "& .action": {
      marginTop: "auto",
      color: color.turquesa,
      display: "flex",
      aligItems: "center",
      justifyContent: "center",
      width: "100%",
      border: `1px solid ${color.turquesa}`,
      borderRadius: size.small,
      padding: `${size.small}px 0`,
    },
    // paddingLeft: size.small,
  },
}))
export const ProductCard = ({
  product,
  shoppingCart,
  setShoppingCart,
  productMatchCart,
  viewCart,
}) => {
  const classes = useStyles()
  const defaultMiniCart = [
    {
      select: 0,
      title: product.title,
      tag: product.variants ? product.variants.tag : null,
      price: product.price,
      quantity: 1,
    },
  ]

  const [openModal, setOpenModal] = useState(false)
  const [miniCart, setMiniCart] = useState([])
  let lenghtMiniCart = miniCart.length
  let variants = [{ ...product }]
  if (product.variants) {
    let newData = [{ ...variants[0], tag: product.variants.tag }]
    product.variants.list.forEach(variant => {
      let ProcessedVariant = {}
      Object.keys(variant).forEach((key, i) => {
        if (Object.values(variant)[i])
          ProcessedVariant[key] = Object.values(variant)[i]
      })
      newData.push({
        ...variants[0],
        ...ProcessedVariant,
      })
    })
    variants = newData
  }

  let totalQuantity = 0
  miniCart && miniCart.forEach(({ quantity }) => (totalQuantity += quantity))

  let totalPrice = 0
  miniCart &&
    miniCart.forEach(({ price, quantity }) => (totalPrice += price * quantity))

  useEffect(() => {
    let addedProduct = {
      ...product,
      variantName: product.variants ? product.variants.name : false,
      variants: [...miniCart],
    }
    let productMatch = search(shoppingCart, "id", addedProduct.id)
    let newData = [...shoppingCart]
    if (miniCart.length !== 0) {
      // setCart({ ...cart, products: [...cart.products, addedProduct] })
      if (productMatch) {
        newData.splice(productMatch.index, 1, addedProduct)
        setShoppingCart(newData)
      } else {
        newData = [...newData, addedProduct]
        setShoppingCart(newData)
      }
    } else {
      if (productMatch) {
        newData.splice(productMatch.index, 1)
        setShoppingCart(newData)
      }
    }
  }, [miniCart])
  const { money } = useContext(CartContext)
  console.log(product.img)
  const imgContainerStyles = {
    width: 200,
    height:
      product.img &&
      product.img.asset &&
      product.img.asset.metadata &&
      product.img.asset.metadata.dimensions &&
      (product.img.asset.metadata.dimensions.height * 200) /
        product.img.asset.metadata.dimensions.width,
    position: "relative",
  }
  const imgStyles = {
    position: "absolute",
    // backgroundPositionX: "10%",
    width: "100%",
    // height: "1500%",
    // height: product.img.hotspot
    // ? `${product.img.hotspot.height * 100}%`
    // : "100%",
  }
  // console.log(product.img)
  return (
    <Card
      className={classes.Card}
      hidden={viewCart ? (productMatchCart ? false : true) : false}
    >
      <CardActionArea
        onClick={() => {
          setOpenModal(true)
        }}
      >
        <Box className={classes.Container}>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            className={classes.ProductImgContainer}
          >
            <Img
              className={"img"}
              fluid={product.img.asset.fluid}
              alt={product.title}
            />
          </Box>
          <div className={classes.ProductInfo}>
            <Box>
              <Typography className="title" variant="h6">
                {product.title}
              </Typography>
              <TagPrice className="price">
                {product.price} {money}
              </TagPrice>
            </Box>
            {lenghtMiniCart !== 0 && (
              <>
                {variants.length !== 1 && (
                  <>
                    <Typography variant="caption">
                      {product.variants.name}:
                    </Typography>
                    <Box>
                      {miniCart.map((variantProduct, i) => {
                        return (
                          <Variant
                            key={i}
                            tag={variantProduct.tag}
                            variantProduct={variantProduct}
                            variantButton="outlined"
                          ></Variant>
                        )
                      })}
                    </Box>
                  </>
                )}
              </>
            )}
            {totalQuantity === 0 ? (
              <Button component="div" color="primary" variant="outlined">
                <AddShoppingCartIcon />
                AÑADIR
              </Button>
            ) : (
              <>
                {variants.length === 1 && <Quantity quantity={totalQuantity} />}
                <Typography>
                  Total: {totalPrice}
                  {money}
                </Typography>
                <Button component="div" color="secondary" variant="contained">
                  <CreateIcon />
                  Editar
                </Button>
              </>
            )}
          </div>
        </Box>
      </CardActionArea>
      <Modal
        title="Sudadera Rick y Morty"
        open={openModal}
        onClose={() => {
          setOpenModal(false)
          // setMiniCart([])
        }}
      >
        <ProductInfo
          miniCart={miniCart}
          setMiniCart={setMiniCart}
          variantName={product.variants ? product.variants.name : false}
          variants={variants}
          totalPrice={totalPrice}
          totalQuantity={totalQuantity}
          onClick={() => {
            setOpenModal(false)
          }}
          cancelButton={() => {
            setMiniCart([])
            setOpenModal(false)
          }}
        ></ProductInfo>
      </Modal>
    </Card>
  )
}
